import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDaimlerComponent } from './simple-icons-daimler.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDaimlerComponent ],
    exports:      [ SimpleIconsDaimlerComponent ],
    bootstrap:    []
})
export class SimpleIconsDaimlerModule {}
